import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { Icon as p } from "../../icon/icon.js";
import "react";
import { Text as f } from "../../text/text.js";
import n from "clsx";
import { b as l } from "../../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import { FormItemDescription as h } from "./form-item-description.js";
import { FormItemError as F } from "./form-item-error.js";
import { FormItemLabel as _ } from "./form-item-label.js";
import { s as o } from "../../../form-item.module-Bfr_MBaI.js";
const D = ({
  fieldIds: m,
  label: e,
  description: a,
  error: r,
  hideLabels: i,
  marginBottom: c,
  children: d
}) => /* @__PURE__ */ s(
  "div",
  {
    className: n(o["form-item"], {
      [o["form-item--has-hidden-labels"]]: i,
      [o["form-item--margin-bottom"]]: c
    }),
    "data-testid": `form-item--${m.id}`,
    children: [
      !i && e && /* @__PURE__ */ t(
        _,
        {
          id: m.labelId,
          htmlFor: m.id,
          "data-testid": `form-item-label--${m.id}`,
          children: e
        }
      ),
      a && /* @__PURE__ */ t(
        h,
        {
          id: m.descriptionId,
          "data-testid": `form-item-description--${m.id}`,
          children: a
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          className: n(o["form-item__control"], {
            [o["form-item__control--no-top-padding"]]: i
          }),
          "data-testid": `form-item-control--${m.id}`,
          children: d
        }
      ),
      (r == null ? void 0 : r.message) && /* @__PURE__ */ s(
        F,
        {
          id: m.errorId,
          "data-testid": `form-item-error--${m.id}`,
          children: [
            /* @__PURE__ */ t(p, { icon: l }),
            /* @__PURE__ */ t("div", { className: o["form-item__error-message"], children: /* @__PURE__ */ t(f, { as: "p", color: "inherit", children: r.message }) })
          ]
        }
      )
    ]
  }
);
export {
  D as FormItem
};
